export const Created = 0
export const CustomerApproved = 1
export const CustomerEdited = 2
export const ExecutorDeclined = 3
export const ExecutorApproved = 4
export const InvoiceCreated = 5

export const GetStatusText = status => {
    switch (status) {
        case CustomerApproved:
            return 'Подтверждён заказчиком'

        case CustomerEdited:
            return 'Исправлен заказчиком'

        case ExecutorDeclined:
            return 'Отклонён поставщиком'

        case ExecutorApproved:
            return 'Подтверждён поставщиком'

        case InvoiceCreated:
            return 'Счёт-фактура создан'

        default:
            return 'Не подтверждён'
    }
}

export const GetStatusVariant = status=>{
        switch (status) {
        case ExecutorApproved:
                return 'green white--text'
        case InvoiceCreated:
                return 'light-blue darken-4 white--text'
        case CustomerApproved:
                return 'teal darken-2 white--text'
        case ExecutorDeclined:
                return 'red white--text'
        case CustomerEdited:
                return 'orange darken-3 white--text'
        default:
            return 'blue-grey white--text'
    }
}